// extracted by mini-css-extract-plugin
module.exports = {"header":"Drawer-module__header___2Nx_4","body":"Drawer-module__body___372-m"};